// *Reports* (B10 S15; DC-210 "Reports is one page, seven tabs, one report shape."; CR-040 "Reporting events -> Read
// model -> Persona dashboard -> Drill-down/export"; CR-041 "Executive dashboard"). The tabs are the report families the
// reader may open (`report.options`, his tab order, the union over the roles they hold); `#reports` opens the first,
// `#reports/<family>?<spec>` that family with its filter spec. The page header carries the reader's reporting scope in
// his matrix words (*Own reqs*, *Assigned*, *Enterprise* …): what every figure below is counted over.

import { McPage } from "@/shell/page";
import { ErrorStrip, NAV_ITEM_LABELS, PageHeader, Stack, Tabs } from "@/mc";
import { reportOptions } from "@/api/tools";
import { errorText, useRead } from "@/api/useTool";
import { go, type Route } from "@/router";
import { ReportTab } from "./ReportTab";
import { familyLabel } from "./labels";
import { familyOf, parseDrillState, parseReportQuery, reportHref, rptHs } from "./spec";

export function ReportsPage({ route }: { route: Route }) {
  const index = useRead(["report", "options", null], () => reportOptions({}));
  const families = index.data?.families ?? [];
  const asked = familyOf(route.raw);
  const family = asked ?? index.data?.family ?? undefined;
  const { family: _family, ...spec } = parseReportQuery(route.raw);
  const drill = parseDrillState(route.raw);
  // A tab keeps the period the reader chose; filters, grouping and sort belong to one report's dimensions.
  const carried = spec.period ? { period: spec.period } : undefined;
  return (
    <McPage>
      <Stack>
        <PageHeader title={NAV_ITEM_LABELS.reports} meta={index.data?.scope_words} loading={index.isLoading} />
        {index.error ? (
          <ErrorStrip
            message={errorText(index.error)}
            problem={{ status: index.error.status, refusal_code: index.error.code, detail: index.error.message, request_id: index.error.requestId }}
          />
        ) : null}
        {families.length > 0 ? (
          <Tabs
            label={NAV_ITEM_LABELS.reports}
            route
            active={family}
            items={families.map((f) => ({
              key: f.key,
              label: familyLabel(f.key) ?? f.key,
              href: reportHref(f.key, carried),
              hs: rptHs("tab", f.key),
            }))}
          />
        ) : null}
        {family ? <ReportTab key={family} family={family} spec={spec} drill={drill} onNavigate={go} /> : null}
      </Stack>
    </McPage>
  );
}
